import validate from 'jquery-validation';
import { getTranslatedMessages } from './translates';
validate;

$('.forgot-form').validate({
    rules: {
        email: {
            required: true,
            email: true,
        },
    },
    messages: getTranslatedMessages(),
});
